<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="name"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :show-borders="false"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="10" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Site Name" />
      <dx-column data-field="has_https" caption="HTTPS Enabled" :cell-template="'httpsTemplate'" />
      <dx-column data-field="ports" caption="Ports" :cell-template="'portsTemplate'" />
      <dx-column data-field="server_name" caption="Server Name" />
      <dx-column data-field="source" caption="Source" />

      <!-- <dx-master-detail :enabled="true" template="detailTemplate" /> -->

      <template #httpsTemplate="{ data }">
        <span :class="data.has_https ? 'tag tag-green' : 'tag tag-red'">
          {{ data.has_https ? 'Yes' : 'No' }}
        </span>
      </template>

      <template #portsTemplate="{ data }">
        <span class="tag tag-blue" v-for="(port, idx) in data.ports" :key="idx">{{ port }}</span>
      </template>

      <template #detailTemplate="{ data }">
        <div>
          <h4>Raw Nginx Config:</h4>
          <pre class="raw-content">{{ data.raw_content }}</pre>
        </div>
      </template>

    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
    import {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxPager,
        DxFilterRow,
        // DxMasterDetail
    } from 'devextreme-vue/data-grid';
    
    import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
    import axios from 'axios';

    export default {
      name: 'NginxDockerConfigs',
      components: {
          DxDataGrid,
          DxColumn,
          DxPaging,
          DxPager,
          DxFilterRow,
          // DxMasterDetail,
          DxLoadIndicator
      },
      data() {
          return {
          title: 'Docker Nginx Site Configs',
          loading: true,
          dataSource: []
          };
      },
      mounted() {
          this.loadConfigs();
      },
      methods: {
          // async loadConfigs() {
          //   try {
          //       const response = await axios.get('/api/internal/nginx/sites');
          //       // const json = await response.json();
          //       // const dockerConfigs = json.docker || {};
          //       const dockerConfigs = Array.isArray(response.data.docker) ? response.data.docker : [];
          //       const flattened = [];

          //       Object.entries(dockerConfigs).forEach(([name, config]) => {
          //       ['sites_enabled', 'sites_available'].forEach((type) => {
          //           if (Array.isArray(config[type])) {
          //           config[type].forEach((entry) => {
          //               flattened.push({
          //               name,
          //               ...entry
          //               });
          //           });
          //           }
          //       });
          //       });

          //       this.dataSource = flattened;
          //   } catch (error) {
          //       console.error('Failed to load Docker site configs:', error);
          //   } finally {
          //       this.loading = false;
          //   }
          // }

        async loadConfigs() {
          try {
            const response = await axios.get('/api/internal/nginx/sites');
            const dockerConfigs = response.data.docker || {};
            const flattened = [];

            Object.entries(dockerConfigs).forEach(([name, config]) => {
              ['sites_enabled', 'sites_available'].forEach((type) => {
                if (Array.isArray(config[type])) {
                  config[type].forEach((entry) => {
                    flattened.push({
                      name,
                      ...entry
                    });
                  });
                }
              });

              // Optional: also check conf_d if needed
              if (Array.isArray(config.conf_d)) {
                config.conf_d.forEach((entry) => {
                  flattened.push({
                    name,
                    ...entry
                  });
                });
              }
            });

            this.dataSource = flattened;
          } catch (error) {
            console.error('Failed to load Docker site configs:', error);
          } finally {
            this.loading = false;
          }
        }

      }
    };
</script>

<style scoped>
  .loading-overlay {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 10;
  }

  .tag {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.75rem;
    margin-right: 4px;
  }

  .tag-green {
    background-color: #c8e6c9;
    color: #256029;
  }

  .tag-red {
    background-color: #ffcdd2;
    color: #c63737;
  }

  .tag-blue {
    background-color: #bbdefb;
    color: #0d47a1;
  }

  .raw-content {
    background-color: #f5f5f5;
    padding: 10px;
    white-space: pre-wrap;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>
